import React from 'react';
import { AppComponentProps } from '../typescriptHelpers';
import Text from 'antd/lib/typography/Text';
import { titleStyle, pageHeaderStyle, antGrey } from './styles/globalStyles';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ProPageHeader } from '@ant-design/pro-layout';

import Layout from 'antd/lib/layout';
import { useHistory } from 'react-router-dom';

interface PageLayoutProps extends AppComponentProps {
    component: React.ComponentType<AppComponentProps>;
    title: string;
    description: string;
    banners?: React.ReactNode;
    backNavigationRoute?: string;
}

const PageLayout: React.FC<PageLayoutProps> = (props: PageLayoutProps) => {
    const { component: Component, title, description, banners, backNavigationRoute, ...rest } = props;

    const history = useHistory();

    return (
        <Layout
            style={{
                backgroundColor: 'white',
                position: 'relative',
            }}
        >
            {banners}
            <div style={{ padding: 24, paddingBottom: 95, overflow: 'auto' }}>
                <ProPageHeader
                    prefixedClassName="page-header"
                    title={
                        <Text style={titleStyle} type="secondary">
                            {title}
                        </Text>
                    }
                    style={{ ...pageHeaderStyle, paddingRight: 0 }}
                    onBack={props.backNavigationRoute ? () => history.push(backNavigationRoute) : null}
                    backIcon={props.backNavigationRoute ? <ArrowLeftOutlined style={{ color: antGrey.grey7 }} /> : null}
                />
                {description && <Text>{description}</Text>}
                <div style={{ paddingBlockStart: description ? '48px' : '20px' }}>
                    <Component {...rest} />
                </div>
            </div>
        </Layout>
    );
};

export default PageLayout;
